module.exports = __webpack_public_path__ + "static/fipcspottyg2-e6b0b2694d5004ecd88657d4458e6895.jpeg";